import { z } from 'zod';

import { BooleanParamSchema } from '../../common/boolean-param/boolean-param';
import { UuidSchema } from '../../common/id/id';
import { IdsParamSchema } from '../../common/ids-param/ids-param';
import { makeListQuery } from '../../common/list-query/list-query';
import { DiscountSourceSchema } from '../discount-source/discount-source';

/**
 * The discount-rule list's filters (N7).
 *
 * `source` + `sourceId` together answer "what does finishing THIS course pay?",
 * which is the question the course detail page asks when it shows an author what
 * their work is worth.
 */
export const DiscountRulesListQuerySchema = makeListQuery({
  isActive: BooleanParamSchema.optional(),
  source: DiscountSourceSchema.optional(),
  sourceId: UuidSchema.optional(),
  search: z.string().trim().min(1).max(160).optional(),
  /**
   * Resolve-by-ids for the admin `ServerSelect` — see `IdsParamSchema`.
   *
   * `DISCOUNT_RULE_FILTER_SPEC` has declared this since the repository was
   * written, but `makeListQuery` is `.strict()`, so `?ids=` was a 422 and the
   * entry was unreachable. It lands with its first consumer — the offer-code
   * screen's rule picker, which holds a saved `discountRuleId` and must name it
   * whatever page the picker happens to be showing (P23b2).
   */
  ids: IdsParamSchema.optional(),
});

export type DiscountRulesListQuery = z.infer<typeof DiscountRulesListQuerySchema>;
